import { Card, Badge, Row, Col } from 'react-bootstrap';

import ToolButtons from './components/ToolButtons';

import { IcebergIcon } from '@tradesolution/iceberg-ui-react';

import { EndringsMelding } from 'services/QAApi/types';

import { formatBehandlesAvItem } from '../../../../../../utils';

import Style from './index.module.css';

interface Props {
  changeRequest: EndringsMelding;
  recievedAt: string;
  selected: boolean;
}

const ChangeRequestCard = (props: Props) => {
  const isExistingEnhet = props.changeRequest.changesMightBeRelatedToEnhetId;
  const isNedlagtDatoForEnhet = props.changeRequest.changes.nedlagtDato;
  const isInnmelding =
    (props.changeRequest.changes.medlemFraOgMedDato || props.changeRequest.changes.medlemHos) &&
    !props.changeRequest.changes.medlemTilOgMedDato;
  const isUtmelding = props.changeRequest.changes.medlemTilOgMedDato;

  const getDisplayNameForStatus = (status: string) =>
    status === 'FolgesOpp' ? 'Følges opp' : status;

  const getChangeRequestStatusBadge = (changeRequest: EndringsMelding) => {
    if (changeRequest.status === 'Avvist') {
      return <Badge bg="success float-end">Avvist</Badge>;
    }
    if (changeRequest.status === 'Behandlet') {
      return <Badge bg="success float-end">Behandlet</Badge>;
    }
    if (changeRequest.status === 'FolgesOpp') {
      return <Badge bg="success float-end">Følges opp</Badge>;
    }
    if (changeRequest.status === 'VaskingFeilet') {
      return <Badge bg="danger float-end">Vasking feilet</Badge>;
    }
    return null;
  };

  return (
    <Card className={props.selected ? Style.qaCardSelected : Style.qaCard}>
      <Card.Header>
        <Card.Title>
          {props.changeRequest.title}
          {getChangeRequestStatusBadge(props.changeRequest)}
        </Card.Title>

        <div className={Style.optionsContainer}>
          <div className={Style.cardStatusContainer}>
            {props.changeRequest.behandlesAv.length > 0 && (
              <IcebergIcon
                className={Style.eyeIcon}
                icon="eye-open"
                color="grey"
                size="sm"
                title={props.changeRequest.behandlesAv
                  .map((o) => formatBehandlesAvItem(o))
                  .join('\r\n')}
              />
            )}
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <Row className="mb-2">
          <Col>{props.selected && <ToolButtons changeRequest={props.changeRequest} />}</Col>
        </Row>
        <Row className="mb-2">
          <Col>
            {!isExistingEnhet && (
              <Badge className="me-1" bg="primary">
                Ny enhet
              </Badge>
            )}
            {isExistingEnhet && (
              <Badge className="me-1" bg="success">
                Enhet funnet
              </Badge>
            )}
            {isInnmelding && (
              <Badge className="me-1" bg="success">
                Innmelding
              </Badge>
            )}
            {isUtmelding && (
              <Badge className="me-1" bg="warning">
                Utmelding
              </Badge>
            )}
            {isNedlagtDatoForEnhet && (
              <Badge className="me-1" bg="warning">
                Nedleggelse
              </Badge>
            )}
          </Col>
        </Row>
      </Card.Body>
      <Card.Footer className={Style.cardFooter}>
        <div className={Style.cardFooterTextContainer}>
          <p className={Style.cardFooterText}>
            {getDisplayNameForStatus(props.changeRequest.status)} :{' '}
            {props.changeRequest.lastChangedBy}
          </p>
          <p className={Style.cardFooterText}>
            Kilde:<span> </span>
            {props.changeRequest.contactEmail &&
              props.changeRequest.contactEmail + ' (' + props.changeRequest.sentBySystem + ')'}
            {!props.changeRequest.contactEmail && props.changeRequest.sentBy}
            {!props.changeRequest.contactEmail &&
              props.changeRequest.sentBy !== props.changeRequest.sentBySystem &&
              ' (' + props.changeRequest.sentBySystem + ')'}
          </p>
          <p className={Style.cardFooterText}>{props.recievedAt} ago</p>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default ChangeRequestCard;
